<template>

  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
    :table-config-options="tableConfigOptions"
  >
    <template #create-button>
      <b-button
        v-b-toggle.sidebar-create-quote-distribution
        variant="primary"
      >
        {{ $t('Distribution') }}
      </b-button>
    </template>
    <template #cell(from_org)="{ data }">
      {{ $langName(data.value.name) }}
    </template>

    <template #cell(period)="{ data }">
      {{ data.value.admission_year + '-' + data.value.name }}
    </template>

    <template #cell(status)="{ data }">
      <b-badge :variant="getQuoteDistributionStatusColor(data.value)">
        {{ $langName(getQuoteDistributionStatus(data.value).name) }}
      </b-badge>
    </template>

    <template #cell(file)="{data}">
      <b-link
        v-if="data.value"
        :href="data.value"
        download="file"
        target="_blank"
      >
        <feather-icon
          icon="DownloadIcon"
          class="cursor-pointer"
          size="16"
        />
      </b-link>
    </template>
    <!-- Column: Actions -->
    <template #cell(actions)="{data}">

      <div class="text-nowrap">
        <feather-icon
          icon="EyeIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="$router.push({ name: 'additional-quote-view', params: { id: data.item.id }})"
        />
      </div>
    </template>
  </l-table>
</template>

<script>
import {
  BButton, VBToggle, BLink, BBadge,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import quoteDistributionOtmModule from '@/store/quote-distribution-otm/index'
import periodModule from '@/store/period/index'
import Create from './Create.vue'
import LTable from '@/views/components/LTable.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    LTable,
    BButton,
    BLink,
    Create,
    BBadge,
  },
  created() {
    // this.$store.commit(`${this.MODULE_NAME}/FRESH`)
    // this.$store.dispatch('staticModule/quoteDistributionTypes')
  },
  methods: {
    getQuoteDistributionType(id) {
      return this.$store.getters['staticModule/getQuoteDistributionType'](id)
    },
    getQuoteDistributionStatus(id) {
      return this.$store.getters['staticModule/getQuoteDistributionStatus'](id)
    },
    getQuoteDistributionStatusColor(id) {
      return this.$store.getters['staticModule/getQuoteDistributionStatusColor'](id)
    },
    refetchData() {
      this.$refs.LTable.refetchData()
    },
  },
  setup() {
    const MODULE_NAME = 'quoteDistributionOtm'
    const MODULE_PERIOD = 'period'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, quoteDistributionOtmModule)
    if (!store.hasModule(MODULE_PERIOD)) store.registerModule(MODULE_PERIOD, periodModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
      if (store.hasModule(MODULE_PERIOD)) store.unregisterModule(MODULE_PERIOD)
    })

    return {
      ...config(MODULE_NAME),
      MODULE_NAME,
    }
  },
}
</script>
